/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Win_S1Inputs */

const en_wc_dl_win_s1 = /** @type {(inputs: Wc_Dl_Win_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the x64 .msi installer (or ARM64 for Snapdragon laptops).`)
};

/**
* | output |
* | --- |
* | "Download the x64 .msi installer (or ARM64 for Snapdragon laptops)." |
*
* @param {Wc_Dl_Win_S1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_win_s1 = /** @type {((inputs?: Wc_Dl_Win_S1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Win_S1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_win_s1(inputs)
});
export { wc_dl_win_s1 as "wc.dl.win.s1" }